import PropTypes from 'prop-types';
import React from 'react';

import { getProviderColor, getProviderInitials } from '../../helpers';
import styles from './ProviderAvatars.module.scss';

const ProviderAvatars = ({ name }) => {
  if (!name) return null;

  return (
    <span className={styles.root}>
      <span
        className={styles.avatar}
        style={{ background: getProviderColor(name) }}
        title={name}
        aria-hidden="true"
      >
        {getProviderInitials(name)}
      </span>
      <span>{name}</span>
    </span>
  );
};

ProviderAvatars.propTypes = {
  name: PropTypes.string,
};

export default ProviderAvatars;
